<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('flight_informations')"
    :loading="loading"
    color="info"
    activator-icon
    @escape="closeDialog"
    @open="showDialogFlightInfo"
  >
    <template v-slot:info>
      <v-skeleton-loader
        v-if="!flightInfo"
        type="article, article, article"
      />
      <v-card-text
        v-if="flightInfo"
        id="flight-info"
      >
        <material-card
          color="accent"
          :title="$t('basic_informations')"
          class="my-6 py-2 card-block"
        >
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.date') }}:
            </v-col>
            <v-col> {{ flightInfo.date | dateFormat }} </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.reg_num') }}:
            </v-col>
            <v-col> {{ flightInfo.plane.reg_num }} </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.pic') }}:
            </v-col>
            <v-col> {{ flightInfo.pic.name }} </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.sic') }}:
            </v-col>
            <v-col> {{ flightInfo.sic ? flightInfo.sic.name : '' }} </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.instructor_id') }}:
            </v-col>
            <v-col> {{ flightInfo.instructor ? flightInfo.instructor.name : '' }} </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.landing') }}:
            </v-col>
            <v-col> {{ flightInfo.landing }} </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4" md="4" class="text-h6 font-weight-medium text-right">
              {{ $t('fields.task') }}:
            </v-col>
            <v-col> {{ $t('types.'+flightInfo.task.name) }} </v-col>
          </v-row>
        </material-card>
        <v-row>
          <v-col cols="12" md="6">
            <material-card
              color="accent"
              :title="$t('fields.takeoff')"
              class="mb-6 pb-2 card-block"
            >
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.takeoff_blocktime') }}:
                </v-col>
                <v-col> {{ flightInfo.takeoff_blocktime | timeFormat }} </v-col>
              </v-row>
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.takeoff_time') }}:
                </v-col>
                <v-col> {{ flightInfo.takeoff_time | timeFormat }} </v-col>
              </v-row>
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.airport') }}:
                </v-col>
                <v-col> {{ flightInfo.takeoff_airport.icao }} </v-col>
              </v-row>
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.counter') }}:
                </v-col>
                <v-col> {{ flightInfo.takeoff_counter }} </v-col>
              </v-row>
            </material-card>
          </v-col>
          <v-col cols="12" md="6">
            <material-card
              color="accent"
              :title="$t('fields.landing')"
              class="pb-2 card-block"
            >
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.landing_time') }}:
                </v-col>
                <v-col> {{ flightInfo.landing_time | timeFormat }} </v-col>
              </v-row>
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.landing_blocktime') }}:
                </v-col>
                <v-col> {{ flightInfo.landing_blocktime | timeFormat }} </v-col>
              </v-row>
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.airport') }}:
                </v-col>
                <v-col> {{ flightInfo.landing_airport.icao }} </v-col>
              </v-row>
              <v-row dense>
                <v-col class="text-h6 font-weight-medium text-right">
                  {{ $t('fields.counter') }}:
                </v-col>
                <v-col> {{ flightInfo.landing_counter }} </v-col>
              </v-row>
            </material-card>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call } from 'vuex-pathify'

  export default {
    name: 'FlightInformations',
    props: {
      flight: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        dialogInfo: false,
        flightInfo: null,
        loading: false,
      }
    },
    computed: {
      // loading: get('app/loading'),
    },
    watch: {
      dialogInfo (val) {
        // this.showDialogFlightInfo()
        val || this.closeDialog()
      },
      flight (val) {
      },
    },
    mounted () {
      // this.showDialogFlightInfo(this.flight)
    },
    methods: {
      getFlightInfo: call('flightGlider/info'),
      async showDialogFlightInfo () {
        console.log('showDialogFlightInfo')
        this.loading = true
        await this.getFlightInfo({ id: this.flight.flight_id ?? this.flight.id }).then(response => {
          this.flightInfo = response
          this.loading = false
          // this.dialogFlightInfo = true
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      closeDialog () {
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)

#flight-info
  .row
    padding-top: 0px
    padding-bottom: 0px

</style>
